import React from "react";
import Button from "../UI/Button";

export default function AvailableOn() {
  return (
    <div className="flex flex-col justify-center  mt-10 relative 2xl:h-[950px] h-[750px] ">
      <img
        src="/images/home/fire.svg"
        alt="fire"
        className=" absolute -top-10 lg:block hidden right-0 left-0 xl:-translate-x-24 -translate-x-20 mx-auto 2xl:h-[950p h-[750px] x] "
      />
      <img
        src="/images/home/fire-mobile.png"
        alt="fire"
        className="absolute lg:hidden right-0 left-0 mx-auto"
      />

      <div className="z-10 flex flex-col text-center items-center justify-around text-white font-Helvetica 2xl:h-[950px] lg:h-[750px] h-[600px] ">
        <div className="uppercase 2xl:text-[50px] text-[20px] lg:text-3xl ">
          Are you
          <span className="font-Red-Undead text-[#3B9A00] block text-6xl lg:text-8xl leading-[120px] lg:leading-[120px]  2xl:text-[134px] 2xl:leading-[140px]">
            ready
          </span>
          for
          <div
            className="font-Red-Undead purge-text  lg:w-full w-60 lg:mt-0 mt-10 text-center  block text-6xl lg:text-8xl lg:leading-[120px]  2xl:text-[134px] 2xl:leading-[140px]"
            style={{
              
            }}
          >
            the purge?
          </div>
        </div>

        <div className="text-sm lg:text-lg lg:w-full w-80 my-10 ">
          Purge Town is a single player NFT shooting game, where all the action
          takes place in one <br /> arena. Obliterate wave after wave and fight
          your way through.
        </div>

        <div className="text-xs lg:text-2xl">Are you ready to purge?</div>

        <div className="my-4 flex justify-center font-bold lg:text-3xl text-base items-center space-x-6 lg:space-x-12">
          <div className="">Available On</div>

          <img
            src="/images/home/windows.svg"
            alt="windows"
            className="inline w-10 lg:w-20"
          />

          <img
            src="/images/home/android.svg"
            alt="android"
            className="inline w-10 lg:w-20"
          />
        </div>

        <div className=" space-x-8 hidden lg:flex">
          <Button
            width="184px"
            height="48px"
            radius="21px"
            isGreen={true}
            text="Play Now"
          />
          <Button width="184px" height="48px" radius="21px" text="Buy Now" />
        </div>
        <div className="lg:hidden flex space-x-6 mt-4">
          <Button
            width="130px"
            height="34px"
            radius="21px"
            isGreen={true}
            text="Play Now"
          />
          <Button width="130px" height="34px" radius="21px" text="Buy Now" />
        </div>
      </div>
    </div>
  );
}
